const initialState = {
    pharmacyViewDetailsApproval:[],
    pharmacyPermissionsApproval:{},
    pharmacyListsApproval: [],
    pharmacyListsIdApproval:[],
    pharmacyStatusApproval: [],
    changedPharmacyStatusApproval : [],
    loadingPharmacyApproval: false,
    errorsPharmacyApproval: {},
    pharmacyIdsApproval:"",
}

const  pharmacyReducerApproval = (state = initialState, action) => {
    switch (action.type) {
        case "GET_PHARMACYLIST_PENDING_APPROVAL":
        case "ADD_PHARMACY_BASIC_PENDING_APPROVAL":
        case "ADD_PHARMACY_DL_PENDING_APPROVAL":
        case "ADD_PHARMACY_OWNER_PENDING_APPROVAL":
        case "ADD_PHARMACIST_PENDING_APPROVAL":
        case "ADD_GST_PAN_PENDING_APPROVAL":
        case "ADD_LOCATED_HOSPITAL_PENDING_APPROVAL":
        case "ADD_PHARMACY_AlERT_PENDING_APPROVAL":
        case "ADD_BACK_LIST_PENDING_APPROVAL":
        case "ADD_GRIEVANCE_PENDING_APPROVAL":
        case "UPDATE_PHARMACY_PENDING_APPROVAL":
        case "UPDATE_PHARMACY_STATUS_PENDING_APPROVAL":
        case "UPDATE_PHARMACY_BASIC_PENDING_APPROVAL":
        case "DELETE_PHARMACY_PENDING_APPROVAL":
        case "GET_PHARMACYLISTBYID_PENDING_APPROVAL":
        case "GET_PHARMACYVIEWLISTBYID_PENDING_APPROVAL":
            return { ...state, loadingPharmacyApproval: true , errorsPharmacyApproval: {}  };

        case "GET_PHARMACYLIST_FULFILLED_APPROVAL":
            return {
                ...state,
                loadingPharmacyApproval: false,
                pharmacyListsApproval: action.payload,
                pharmacyCountApproval: action.count,
                pharmacyPermissionsApproval:action.permissions,
            };

        case "ADD_PHARMACY_BASIC_FULFILLED_APPROVAL":
            return {
                ...state,
                loadingPharmacyApproval: false,
                changedPharmacyStatusApproval: action.payload,
                pharmacyIdsApproval:action.payload?.data?.id  || state.pharmacyIdsApproval,
                errorsPharmacyApproval: {},
            };
        case "GET_PHARMACYVIEWLISTBYID_FULFILLED_APPROVAL":
            return {
                ...state,
                loadingPharmacyApproval: false,
                pharmacyViewDetailsApproval: action.payload,
            };
            case "UPDATE_PHARMACY_BASIC_FULFILLED_APPROVAL":
                return {
                    ...state,
                    loadingPharmacyApproval: false,
                    changedPharmacyStatusApproval: action.payload,
                    pharmacyIdsApproval:action.payload?.data?.id  || state.pharmacyIdsApproval,
                    errorsPharmacyApproval: {},
                };    

        case "ADD_PHARMACY_DL_FULFILLED_APPROVAL":
            return {
                ...state,
                loadingPharmacyApproval: false,
                changedPharmacyStatusApproval: action.payload,
                pharmacyIdsApproval:action.payload?.data?.id  || state.pharmacyIdsApproval,
                errorsPharmacyApproval: {},
            };

        case "ADD_PHARMACY_OWNER_FULFILLED_APPROVAL":
            return {
                ...state,
                loadingPharmacyApproval: false,
                changedPharmacyStatusApproval: action.payload,
                pharmacyIdsApproval:action.payload?.data?.id  || state.pharmacyIdsApproval,
                errorsPharmacyApproval: {},
            };

        case "ADD_PHARMACIST_FULFILLED_APPROVAL":
            return {
                ...state,
                loadingPharmacyApproval: false,
                changedPharmacyStatusApproval: action.payload,
                pharmacyIdsApproval:action.payload?.data?.id  || state.pharmacyIdsApproval,
                errorsPharmacyApproval: {},
            };

        case "ADD_GST_PAN_FULFILLED_APPROVAL":
            return {
                ...state,
                loadingPharmacyApproval: false,
                changedPharmacyStatusApproval: action.payload,
                pharmacyIdsApproval:action.payload?.data?.id  || state.pharmacyIdsApproval,
                errorsPharmacyApproval: {},
            };

        case "ADD_LOCATED_HOSPITAL_FULFILLED_APPROVAL":
            return {
                ...state,
                loadingPharmacyApproval: false,
                changedPharmacyStatusApproval: action.payload,
                pharmacyIdsApproval:action.payload?.data?.id  || state.pharmacyIdsApproval,
                errorsPharmacyApproval: {},
            };
            
            case "ADD_PHARMACY_AlERT_FULFILLED_APPROVAL":
                console.log("action.payload",action.payload);
                return {
                    ...state,
                    loadingPharmacyApproval: false,
                    changedPharmacyStatusApproval: action.payload,
                    pharmacyIdsApproval:action.payload?.data?.id  || state.pharmacyIdsApproval,
                errorsPharmacyApproval: {},
                };
            case "ADD_BACK_LIST_FULFILLED_APPROVAL":
                return {
                    ...state,
                    loadingPharmacyApproval: false,
                    changedPharmacyStatusApproval: action.payload,
                    pharmacyIdsApproval:action.payload?.data?.id  || state.pharmacyIdsApproval,
                errorsPharmacyApproval: {},
                };
            case "ADD_GRIEVANCE_FULFILLED_APPROVAL":
                return {
                    ...state,
                    loadingPharmacyApproval: false,
                    changedPharmacyStatusApproval: action.payload,
                    pharmacyIdsApproval:action.payload?.data?.id  || state.pharmacyIdsApproval,
                errorsPharmacyApproval: {},
                };
        case "UPDATE_PHARMACY_FULFILLED_APPROVAL":
            return {
                ...state,
                loadingPharmacyApproval: false,
                changedPharmacyStatusApproval: action.payload,
                pharmacyIdsApproval:action.payload?.data?.id  || state.pharmacyIdsApproval,
                errorsPharmacyApproval: {},
            };

        case "UPDATE_PHARMACY_STATUS_FULFILLED_APPROVAL":
            return {
                ...state,
                loadingPharmacyApproval: false,
                changedPharmacyStatusApproval: action.payload,
            };

        case "GET_PHARMACYLISTBYID_FULFILLED_APPROVAL":
            return {
                ...state,
                loadingPharmacyApproval: false,
                pharmacyListsIdApproval: action.payload
            };

        case "DELETE_PHARMACY_FULFILLED_APPROVAL":
            return {
                ...state,
                loadingPharmacyApproval: false,
                changedPharmacyStatusApproval: action.payload
            };

        case "RESET_DELETE_PHARMACYS_STATUS_APPROVAL":
            return {
                ...state,
                loadingPharmacyApproval: false,
                changedPharmacyStatusApproval: [],
                errorsPharmacyApproval:{},
                pharmacyIdsApproval:"",
            };

        case "GET_PHARMACYLIST_REJECTED_APPROVAL":
        case "ADD_PHARMACY_BASIC_REJECTED_APPROVAL":
        case "ADD_PHARMACY_DL_REJECTED_APPROVAL":
        case "ADD_PHARMACY_OWNER_REJECTED_APPROVAL":
        case "ADD_PHARMACIST_REJECTED_APPROVAL":
        case "ADD_GST_PAN_REJECTED_APPROVAL":
        case "ADD_LOCATED_HOSPITAL_REJECTED_APPROVAL":
        case "ADD_PHARMACY_AlERT_REJECTED_APPROVAL":
        case "ADD_BACK_LIST_REJECTED_APPROVAL":
        case "ADD_GRIEVANCE_REJECTED_APPROVAL":
        case "UPDATE_PHARMACY_BASIC_REJECTED_APPROVAL":
        case "UPDATE_PHARMACY_REJECTED_APPROVAL":
        case "UPDATE_PHARMACY_STATUS_REJECTED_APPROVAL":
        case "DELETE_PHARMACY_REJECTED_APPROVAL":
        case "GET_PHARMACYLISTBYID_REJECTED_APPROVAL":
        case "GET_PHARMACYVIEWLISTBYID_REJECTED_APPROVAL":
            return {
                ...state,
                loadingPharmacyApproval: false,
                errorsPharmacyApproval: action.payload
            };

        default:
            return state;
    }
}

export default pharmacyReducerApproval;